// Códigos de capa conocidos del pictograma (coinciden con `pictogram_layers.code`
// del backend). Centralizados para no repetir literales sueltos por el código.
export const LAYER_CODES = Object.freeze({
  PILINGS: 'pilings',
  STRUCTURES: 'structures',
  MODULES: 'modules',
});
